// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"be9e8cbb","28":"bd15f8a2","195":"8844e4d3","307":"9c098bee","400":"322ee5eb","453":"661f9796","455":"75cdf2d3","596":"757a038d","726":"0bc5b4df","977":"bfbf128b"}[chunkId] + ".chunk.js";
};